module.exports = __webpack_public_path__ + "img/12.a823233c.png";